import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import CustomizerComponent from '@bit/gerenciatd.unifiedcomponents.customizer-component';
// import ActionStrip from '@bit/gerenciatd.unifiedcomponents.action-strip';
import CircleImageSlider from '@bit/gerenciatd.unifiedcomponents.circle-image-slider';
import Modal from '@bit/gerenciatd.unifiedcomponents.modal';
import SvgIconLoader from '@bit/gerenciatd.unifiedicons.svg-icon-loader';
import ProductList from '@bit/gerenciatd.unifiedcomponents.product-list';
import ProductItem from '@bit/gerenciatd.unifiedcomponents.product-item';
import HoverEffectCard from '@bit/gerenciatd.unifiedcomponents.hover-effect-card';
import ClickBox from '@bit/gerenciatd.unifiedcomponents.click-box';
import { clientCCLIActions } from '@bit/gerenciatd.telcovid.redux-saga-client-c-c-l-i';
import { registerActions as productsCCLIActions } from '@bit/gerenciatd.telcovid.redux-saga-products-c-c-l-i';
import mainSetup from '../../../config/mainSetup';
import Comunications from '../../components/Comunications';
import WrapperLightBox from '../../components/WrapperLightBox';
import ServicingSection from '../../components/ServicingSection';
import BannerWrapper from '../../components/BannerWrapper';
import { actions } from '../../reducers/home';
import { actions as commonActions } from '../../reducers/common';
import { checkCookie, setCookie, setDataDataToUser } from '../../utils/common.utils';

import './Home.scss';

const Home = () => {
  const { homeInfo, homeInfoState } = useSelector(
    state => state.home
  );
  const {
    consultaDatosLineasMSuccess,
    consultaDatosLineasMFail,
    consultaDatosLineasMInfo,
    consultaDatosLineaFSuccess,
    consultaDatosLineaFFail,
    consultaDatosLineaFInfo,
  } = useSelector(
    state => state.products
  );
  const {
    datosClienteGFail,
    datosClienteGSuccess,
    datosClienteGInfo,
  } = useSelector(
    state => state.client
  );
  const { constants } = useSelector(state => state.common);
  const { userType, userAuth, contextURL } = useSelector(state => state.context.data);
  const {
    context,
  } = useSelector(
    state => state
  );
  const isClient = (userType !== undefined && userType === 'Legado' && userAuth !== undefined && userAuth !== 'MC') || window.location.href.includes('col10mgmt');

  const dispatch = useDispatch();

  const renderHomeModules = (module) => {
    if (Array.isArray(homeInfo) && !homeInfo.length) {
      return null;
    }
    return Object.values(module.data.fields).map((item) => {
      switch (item.name) {
        case 'MODULO_SOLUCIONES_SOLUCIONES_DIGITALES':
          return <CircleImageSlider {...item.fields} />
        case 'MODULO_BANNER_INTERNO':
          return <ClickBox {...item.fields} />
        case 'MODULO_VENTA_CRUZADA_OFERTAS':
          return <ProductList {...item.fields} ItemComponent={ProductItem} />
        default:
          return null;
      }
    });
  };

  // Get data used for the flow logic.
  const getDataFromClient = () => {
    if ((isClient || contextURL.includes('127.0.0.1')) && !sessionStorage.getItem('datosUsuario')) {
      dispatch(clientCCLIActions.getDatosClienteGInit(context));
      dispatch(productsCCLIActions.getConsultaDatosLineasMInit(context));
      dispatch(productsCCLIActions.getConsultaDatosLineaFInit(context));
    }
  }

  useEffect(() => {
    dispatch(actions.getHomeInfoBegins('home_empresas'));
    dispatch(commonActions.getBusinessConstants());
    getDataFromClient();
  }, []);

  useEffect(() => {
    if ((datosClienteGSuccess || datosClienteGFail)
      && (consultaDatosLineasMSuccess || consultaDatosLineasMFail)
      && (consultaDatosLineaFSuccess || consultaDatosLineaFFail)) {
      setDataDataToUser(datosClienteGInfo, consultaDatosLineasMInfo, consultaDatosLineaFInfo);
    }
  }, [
    datosClienteGSuccess, consultaDatosLineaFSuccess, consultaDatosLineasMSuccess,
    consultaDatosLineaFFail, datosClienteGFail, consultaDatosLineasMFail]);


  return (
    <div className="Home">
      {/* <CustomizerComponent
        spaId={mainSetup.projectId}
        activityId="EMP-ACTION-STRIP-HOME"
        component={ActionStrip}
        customProps={{ SvgIconLoader }}
        componentName="ActionStrip"
      /> */}
      {constants ? (
        <CustomizerComponent
          spaId={mainSetup.projectId}
          activityId="EMP-BANNER-HOME"
          component={BannerWrapper}
          componentName="Banner"
          customProps={{
            modalAtencionConfig: (constants && constants.modalAtencionConfig) || null,
            ModalComponent: Modal,
            SvgIconLoader,
          }}
        />
      ) : (
        <Skeleton
          style={{
            width: '100%',
            height: '400px',
          }}
        />
      )}
      <CustomizerComponent
        spaId={mainSetup.projectId}
        activityId="EMP-COMUNICACIONES"
        componentName="Comunicaciones"
        component={Comunications}
      />
      {/* <CustomizerComponent
        spaId={mainSetup.projectId}
        activityId="EMP-NOVEDADES-HOME"
        component={ProductList}
        customProps={{ ItemComponent: ProductItem }}
        componentName="novedades"
      /> */}
      {homeInfoState === 'FETCHING'
        && Array.isArray(homeInfo)
        ? (
          <Skeleton
            style={{
              width: '100%',
              height: '300px',
              marginBottom: '1.5rem',
            }}
          />
        )
        : homeInfo.map(renderHomeModules)
        }
      <CustomizerComponent
        spaId={mainSetup.projectId}
        activityId="EMP-OFERTAS-HOME"
        component={ProductList}
        customProps={{ ItemComponent: ProductItem }}
        componentName="destacados"
      />
      <CustomizerComponent
        spaId={mainSetup.projectId}
        activityId="EMP-NO-TE-PIERDAS-NADA"
        component={ProductList}
        customProps={{ ItemComponent: HoverEffectCard }}
        componentName="no-te-pierdas-nada"
      />
      <CustomizerComponent
        spaId={mainSetup.projectId}
        activityId="EMP-SERVICING-HOME"
        component={ServicingSection}
        componentName="servicing"
      />
      <CustomizerComponent
        spaId={mainSetup.projectId}
        activityId="EMP-LIGHTBOX"
        component={WrapperLightBox}
        singleton={Modal}
      />
    </div>
  );
}


export default Home;
